import React from 'react';
import { LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRECIO } from '../data/content';
export function OfferSection() {
  return <section id="comprar" className="w-full scroll-mt-4 bg-ink py-14 text-cream sm:py-16 lg:py-20" data-id="element-114" data-mp="3lzd7qxum140">
      <div className="mx-auto grid w-full max-w-5xl grid-cols-1 items-center gap-8 px-5 sm:px-8 lg:grid-cols-[1fr_0.9fr] lg:gap-12" data-id="element-115" data-mp="8llvwfwg49k7">
        <div data-id="element-116" data-mp="idzx97jm3e5u">
          <h2 className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl" data-id="element-117" data-mp="ic6rrvkqizzf">
            Una compra inteligente puede empezar a cambiar todo el mes.
          </h2>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-cream/70" data-id="element-118" data-mp="rey2ft5sdrq0">
            No pagás por un archivo suelto: te llevás un sistema completo que volvés a usar todas las
            semanas, mientras sigas haciendo las compras de tu casa.
          </p>
        </div>

        {/* Ticket de compra */}
        <div className="rounded-2xl bg-cream p-6 text-ink sm:p-8" data-id="element-119" data-mp="2y55mna6ij61f">
          <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-120" data-mp="12o1vj352t281">
            Empezá desde tu próxima compra
          </p>
          <h3 className="mt-3 font-display text-2xl font-extrabold uppercase leading-tight tracking-tight" data-id="element-121" data-mp="xvh05x6iuh2e">
            El Protocolo Anti-Inflación
          </h3>

          <div className="mt-5 border-y border-dashed border-ink/25 py-5" data-id="element-122" data-mp="ox52jb78mj0g">
            <div className="flex items-baseline gap-2" data-id="element-123" data-mp="1lmw9wb0mo0no">
              <span className="font-mono text-sm font-bold text-ink-muted" data-id="element-124" data-mp="1lll465nmgitx">ARS</span>
              <span className="font-display text-5xl font-extrabold tracking-tight sm:text-6xl" data-id="element-125" data-mp="1gnt2ijx6dicj">
                {PRECIO}
              </span>
            </div>
            <p className="mt-2 text-sm font-semibold text-ink-soft" data-id="element-126" data-mp="17n4pnsjipo18">
              Pago único · Acceso digital inmediato
            </p>
          </div>

          <CtaButton label="Quiero empezar ahora" className="mt-5" data-id="element-127" data-mp="14g7z9vahnqh" />

          <p className="mt-4 flex items-center justify-center gap-2 text-center text-xs text-ink-muted" data-id="element-128" data-mp="3sc13zmbuvgk8">
            <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-129" data-mp="3tvasrzw6x6b3" />
            Pago seguro · Recibís el acceso apenas confirmás la compra
          </p>
        </div>
      </div>
    </section>;
}